export default __webpack_public_path__ + "static/media/FICHA TÉCNICA - MANGA TOMMY.153bbade.pdf";